import { render, staticRenderFns } from "./addEnt.vue?vue&type=template&id=65f63a89"
import script from "./addEnt.vue?vue&type=script&lang=js"
export * from "./addEnt.vue?vue&type=script&lang=js"
import style0 from "./addEnt.vue?vue&type=style&index=0&id=65f63a89&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports